function d({ list: r, weights: e, rng: o = Math.random }) {
  if (e.length !== r.length)
    throw new Error("weights length does not match list length");
  const h = e == null ? void 0 : e.reduce((t, a) => t + a), l = o() * h;
  let n = 0;
  for (let t = 0; t < r.length; t++)
    if (n += e[t], l < n)
      return r[t];
  throw new Error("error returning a weighted item");
}
export {
  d as randomWeightedItem
};
//# sourceMappingURL=index.js.map
